import React from 'react';

import { Typography, Card, CardContent, CardMedia } from '@mui/material';

import styles from './CardRailItem.module.css';

export interface CardRailItemProps {
  component?: React.ElementType;
  src: string;
  label: string;
  content?: string;
  children?: React.ReactNode;
  overrideClassName?: string;
}

export const CardRailItem = ({
  component,
  src,
  label,
  content,
  children,
  overrideClassName,
}: CardRailItemProps) => {
  return (
    <Card className={overrideClassName || styles.root} elevation={0}>
      <CardMedia
        component={component || 'img'}
        src={src}
        title={label}
        frameBorder="0"
        className={styles.media}
      />

      <CardContent>
        <Typography gutterBottom variant="h3" component="div">
          {label}
        </Typography>
        <Typography color="text.secondary">{content}</Typography>
        {children}
      </CardContent>
    </Card>
  );
};
